import {
  Component,
  OnInit,
  Inject,
} from '@angular/core';
// import { Demo1Component } from '../demo1/demo1.component';

import * as THREE from 'three';
// import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import ThreeGlobe from 'three-globe';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CorporateService } from '../corporate-programs/corporate.service';
// import { reduce } from 'rxjs/operators';

@Component({
  selector: 'app-corporate-hirings',
  templateUrl: './corporate-hirings.component.html',
  styleUrls: ['./corporate-hirings.component.scss'],
})
export class CorporateHiringsComponent implements OnInit {
  panelOpenState = false;
  constructor(public dialog: MatDialog) {}
  openDialog(course:any){
    let dialogRef= this.dialog.open(DialogHiringsDialogComponent ,{
    width: '500px',
    data: { course: course },
    })
  }




  
  // @ViewChild('c') canvasDiv: ElementRef;
  // @ViewChild('labels') canvasLabelsDiv: ElementRef;

  // canvas;
  // renderer;
  // fov = 60;
  // aspect = 2;  // the canvas default
  // near = 0.1;
  // far = 10;
  // camera;
  // controls;
  // scene;
  // pickingScene;
  // tempColor;
  // maxNumCountries = 512;
  // paletteTextureWidth = this.maxNumCountries;
  // paletteTextureHeight = 1;
  // palette;
  // paletteTexture;
  // selectedColor;
  // unselectedColor;
  // oceanColor;

  // loader;
  // geometry;
  // indexTexture;
  // renderRequested;
  // pickingMaterial;
  // texture;
  // material;

  // numCountriesSelected;
  // countryInfos;

  // tempV;
  // cameraToPoint;
  // cameraPosition;
  // normalMatrix;
  // settings;

  // pickHelper;
  // maxClickTimeMs;
  // maxMoveDeltaSq;
  // startPosition;
  // startTimeMs;

  // constructor() {

  // }

  // ngAfterViewInit(){

  //   this.canvas = this.canvasDiv.nativeElement;
  //   this.renderer = new THREE.WebGLRenderer({ canvas: this.canvas });

  //   this.camera = new THREE.PerspectiveCamera(this.fov, this.aspect, this.near, this.far);
  //   this.camera.position.z = 2.5;

  //   this.controls = new OrbitControls(this.camera, this.canvas);
  //   this.controls.enableDamping = true;
  //   this.controls.enablePan = false;
  //   this.controls.minDistance = 1.2;
  //   this.controls.maxDistance = 4;
  //   this.controls.update();

  //   this.scene = new THREE.Scene();
  //   this.scene.background = new THREE.Color('#246');

  //   this.pickingScene = new THREE.Scene();
  //   this.pickingScene.background = new THREE.Color(0);

  //   this.tempColor = new THREE.Color();

  //   this.palette = new Uint8Array(this.paletteTextureWidth * 3);

  //   this.paletteTexture = new THREE.DataTexture(this.palette, this.paletteTextureWidth, this.paletteTextureHeight, THREE.RGBFormat);
  //   this.paletteTexture.minFilter = THREE.NearestFilter;
  //   this.paletteTexture.magFilter = THREE.NearestFilter;

  //   this.selectedColor = this.get255BasedColor('red');
  //   this.unselectedColor = this.get255BasedColor('#444');
  //   this.oceanColor = this.get255BasedColor('rgb(100,200,255)');

  //   this.loader = new THREE.TextureLoader();
  //   this.geometry = new THREE.SphereGeometry(1, 64, 32);

  //   this.indexTexture = this.loader.load('https://threejsfundamentals.org/threejs/resources/data/world/country-index-texture.png', this.render);
  //   this.indexTexture.minFilter = THREE.NearestFilter;
  //   this.indexTexture.magFilter = THREE.NearestFilter;

  //   this.pickingMaterial = new THREE.MeshBasicMaterial({ map: this.indexTexture });
  //   this.pickingScene.add(new THREE.Mesh(this.geometry, this.pickingMaterial));
  //   const fragmentShaderReplacements = [
  //     {
  //       from: '#include <common>',
  //       to: `
  //         #include <common>
  //         uniform sampler2D indexTexture;
  //         uniform sampler2D paletteTexture;
  //         uniform float paletteTextureWidth;
  //       `,
  //     },
  //     {
  //       from: '#include <color_fragment>',
  //       to: `
  //         #include <color_fragment>
  //         {
  //           vec4 indexColor = texture2D(indexTexture, vUv);
  //           float index = indexColor.r * 255.0 + indexColor.g * 255.0 * 256.0;
  //           vec2 paletteUV = vec2((index + 0.5) / paletteTextureWidth, 0.5);
  //           vec4 paletteColor = texture2D(paletteTexture, paletteUV);
  //           // diffuseColor.rgb += paletteColor.rgb;   // white outlines
  //           diffuseColor.rgb = paletteColor.rgb - diffuseColor.rgb;  // black outlines
  //         }
  //       `,
  //     },
  //   ];

  //   this.texture = this.loader.load('https://threejsfundamentals.org/threejs/resources/data/world/country-outlines-4k.png', this.render);
  //   this.material = new THREE.MeshBasicMaterial({map: this.texture});
  //   this.material.onBeforeCompile = function(shader) {
  //     fragmentShaderReplacements.forEach((rep) => {
  //       shader.fragmentShader = shader.fragmentShader.replace(rep.from, rep.to);
  //     });
  //     shader.uniforms.paletteTexture = {value: this.paletteTexture};
  //     shader.uniforms.indexTexture = {value: this.indexTexture};
  //     shader.uniforms.paletteTextureWidth = {value: this.paletteTextureWidth};
  //   };
  //   this.scene.add(new THREE.Mesh(this.geometry, this.material));

  //   this.tempV = new THREE.Vector3();
  //   this.cameraToPoint = new THREE.Vector3();
  //   this.cameraPosition = new THREE.Vector3();
  //   this.normalMatrix = new THREE.Matrix3();

  //   this.settings = {
  //     minArea: 20,
  //     maxVisibleDot: -0.2,
  //   };

  //   this.pickHelper = new GPUPickHelper();
  //   this.maxClickTimeMs = 200;
  //   this.maxMoveDeltaSq = 5 * 5;
  //   this.startPosition = {};
  //   this.startTimeMs;

  //   this.canvas.addEventListener('pointerdown', this.recordStartTimeAndPosition);
  //   this.canvas.addEventListener('pointerup', this.pickCountry);

  //   this.render();
  //   this.loadCountryData();

  //   this.controls.addEventListener('change', this.requestRenderIfNotRequested);
  //   window.addEventListener('resize', this.requestRenderIfNotRequested);

  // }

  // async loadJSON(url) {
  //   const req = await fetch(url);
  //   return req.json();
  // }

  // async loadCountryData() {
  //   this.countryInfos = await this.loadJSON('https://threejsfundamentals.org/threejs/resources/data/world/country-info.json');

  //   const lonFudge = Math.PI * 1.5;
  //   const latFudge = Math.PI;
  //   // these helpers will make it easy to position the boxes
  //   // We can rotate the lon helper on its Y axis to the longitude
  //   const lonHelper = new THREE.Object3D();
  //   // We rotate the latHelper on its X axis to the latitude
  //   const latHelper = new THREE.Object3D();
  //   lonHelper.add(latHelper);
  //   // The position helper moves the object to the edge of the sphere
  //   const positionHelper = new THREE.Object3D();
  //   positionHelper.position.z = 1;
  //   latHelper.add(positionHelper);

  //   const labelParentElem = this.canvasLabelsDiv.nativeElement;
  //   for (const countryInfo of this.countryInfos) {
  //     const {lat, lon, min, max, name} = countryInfo;

  //     // adjust the helpers to point to the latitude and longitude
  //     lonHelper.rotation.y = THREE.MathUtils.degToRad(lon) + lonFudge;
  //     latHelper.rotation.x = THREE.MathUtils.degToRad(lat) + latFudge;

  //     // get the position of the lat/lon
  //     positionHelper.updateWorldMatrix(true, false);
  //     const position = new THREE.Vector3();
  //     positionHelper.getWorldPosition(position);
  //     countryInfo.position = position;

  //     // compute the area for each country
  //     const width = max[0] - min[0];
  //     const height = max[1] - min[1];
  //     const area = width * height;
  //     countryInfo.area = area;

  //     // add an element for each country
  //     const elem = document.createElement('div');
  //     elem.textContent = name;
  //     labelParentElem.appendChild(elem);
  //     countryInfo.elem = elem;
  //   }
  //   this.requestRenderIfNotRequested();
  // }

  ngOnInit(): void {


    
    const N = 50;
    const gData = [...Array(N).keys()].map(() => ({
      lat: (Math.random() - 0.5) * 180,
      lng: (Math.random() - 0.5) * 360,
      size: Math.random() * 1,
      color: ['red', 'white', 'blue', 'green'][Math.round(Math.random() * 3)],
    }));

    fetch(
      'https://globe.gl/example/datasets/ne_110m_populated_places_simple.geojson'
    )
      .then((res) => res.json())
      .then((places) => {
        const Globe = new ThreeGlobe()
          .globeImageUrl('//unpkg.com/three-globe/example/img/earth-dark.jpg')
          .bumpImageUrl(
            '//unpkg.com/three-globe/example/img/earth-topology.png'
          )
          .labelsData(places.features)
          .labelLat((d: any) => d.properties.latitude)
          .labelLng((d: any) => d.properties.longitude)
          .labelText((d: any) => d.properties.name)
          .labelSize((d: any) => Math.sqrt(d.properties.pop_max) * 4e-4)
          // .labelDotRadius((d:any) => Math.sqrt(d.properties.pop_max) * 4e-4)
          .labelColor(() => 'rgba(255, 165, 0, 0.75)')
          .labelResolution(2)

          .hexBinPointsData(places.features)
          .hexBinPointLat((d: any) => d.properties.latitude)
          .hexBinPointLng((d: any) => d.properties.longitude)

          .hexBinPointWeight(1)
          .hexBinResolution(4)
          .hexMargin(0.2)
          .hexTopColor(() => 'orange')
          .hexSideColor(() => 'rgba(255,255,255,0.8)')
          .hexBinMerge(true);

        // Setup renderer
        const renderer = new THREE.WebGLRenderer({
          alpha: true,
          premultipliedAlpha: false,
        });
        renderer.setSize(600, 600);
        renderer.setClearColor(0x000000, 0);
        document.getElementById('bancomGlobe').appendChild(renderer.domElement);

        // Setup scene
        const scene = new THREE.Scene();
        scene.add(Globe);
        // scene.add(mesh);
        scene.add(new THREE.AmbientLight(0xbbbbbb));
        scene.add(new THREE.DirectionalLight(0xffffff, 0.6));

        // Setup camera
        const camera = new THREE.PerspectiveCamera();
        camera.aspect = 800 / 800;
        camera.updateProjectionMatrix();
        camera.position.set(0, 20, 300);
        // camera.position.z = 300;

        const controls = new OrbitControls(camera, renderer.domElement);

        //controls.update() must be called after any manual changes to the camera's transform
        controls.autoRotate = true;
        controls.enableZoom = false;
        controls.update();

        // Add camera controls
        // const tbControls = new TrackballControls(camera, renderer.domElement);
        // tbControls.minDistance = 101;
        // tbControls.rotateSpeed = 5;
        // tbControls.zoomSpeed = 0.8;

        // Kick-off renderer
        (function animate() {
          // IIFE
          // Frame cycle
          // tbControls.update();
          controls.update();
          renderer.render(scene, camera);
          requestAnimationFrame(animate);
        })();
      });
  }

  //   resizeRendererToDisplaySize(renderer) {
  //     const canvas = renderer.domElement;
  //     const width = canvas.clientWidth;
  //     const height = canvas.clientHeight;
  //     const needResize = canvas.width !== width || canvas.height !== height;
  //     if (needResize) {
  //       renderer.setSize(width, height, false);
  //     }
  //     return needResize;
  //   }

  //   render() {
  //     this.renderRequested = false;

  //     if (this.resizeRendererToDisplaySize(this.renderer)) {
  //       const canvas = this.renderer.domElement;
  //       this.camera.aspect = canvas.clientWidth / canvas.clientHeight;
  //       this.camera.updateProjectionMatrix();
  //     }

  //     this.controls.update();

  //     this.updateLabels();

  //     this.renderer.render(this.scene, this.camera);
  //   }

  //   get255BasedColor(color) {
  //     this.tempColor.set(color);
  //     return this.tempColor.toArray().map(v => v * 255);
  //   }

  //   setPaletteColor(index, color) {
  //     this.palette.set(color, index * 3);
  //   }

  //   resetPalette() {
  //     // make all colors the unselected color
  //     for (let i = 1; i < this.maxNumCountries; ++i) {
  //       this.setPaletteColor(i, this.unselectedColor);
  //     }

  //     // set the ocean color (index #0)
  //     this.setPaletteColor(0, this.oceanColor);
  //     this.paletteTexture.needsUpdate = true;
  //   }

  //   updateLabels() {
  //     // exit if we have not loaded the data yet
  //     if (!this.countryInfos) {
  //       return;
  //     }

  //     const large = this.settings.minArea * this.settings.minArea;
  //     // get a matrix that represents a relative orientation of the camera
  //     this.normalMatrix.getNormalMatrix(this.camera.matrixWorldInverse);
  //     // get the camera's position
  //     this.camera.getWorldPosition(this.cameraPosition);
  //     for (const countryInfo of this.countryInfos) {
  //       const { position, elem, area, selected } = countryInfo;
  //       const largeEnough = area >= large;
  //       const show = selected || (this.numCountriesSelected === 0 && largeEnough);
  //       if (!show) {
  //         elem.style.display = 'none';
  //         continue;
  //       }

  //       // Orient the position based on the camera's orientation.
  //       // Since the sphere is at the origin and the sphere is a unit sphere
  //       // this gives us a camera relative direction vector for the position.
  //       this.tempV.copy(position);
  //       this.tempV.applyMatrix3(this.normalMatrix);

  //       // compute the direction to this position from the camera
  //       this.cameraToPoint.copy(position);
  //       this.cameraToPoint.applyMatrix4(this.camera.matrixWorldInverse).normalize();

  //       // get the dot product of camera relative direction to this position
  //       // on the globe with the direction from the camera to that point.
  //       // -1 = facing directly towards the camera
  //       // 0 = exactly on tangent of the sphere from the camera
  //       // > 0 = facing away
  //       const dot = this.tempV.dot(this.cameraToPoint);

  //       // if the orientation is not facing us hide it.
  //       if (dot > this.settings.maxVisibleDot) {
  //         elem.style.display = 'none';
  //         continue;
  //       }

  //       // restore the element to its default display style
  //       elem.style.display = '';

  //       // get the normalized screen coordinate of that position
  //       // x and y will be in the -1 to +1 range with x = -1 being
  //       // on the left and y = -1 being on the bottom
  //       this.tempV.copy(position);
  //       this.tempV.project(this.camera);

  //       // convert the normalized position to CSS coordinates
  //       const x = (this.tempV.x * .5 + .5) * this.canvas.clientWidth;
  //       const y = (this.tempV.y * -.5 + .5) * this.canvas.clientHeight;

  //       // move the elem to that position
  //       elem.style.transform = `translate(-50%, -50%) translate(${x}px,${y}px)`;

  //       // set the zIndex for sorting
  //       elem.style.zIndex = (-this.tempV.z * .5 + .5) * 100000 | 0;
  //     }
  //   }

  //   getCanvasRelativePosition(event) {
  //     const rect = this.canvas.getBoundingClientRect();
  //     return {
  //       x: (event.clientX - rect.left) * this.canvas.width  / rect.width,
  //       y: (event.clientY - rect.top ) * this.canvas.height / rect.height,
  //     };
  //   }

  //   recordStartTimeAndPosition(event) {
  //     this.startTimeMs = performance.now();
  //     const pos = this.getCanvasRelativePosition(event);
  //     this.startPosition.x = pos.x;
  //     this.startPosition.y = pos.y;
  //   }

  //   pickCountry(event) {
  //     // exit if we have not loaded the data yet
  //     if (!this.countryInfos) {
  //       return;
  //     }

  //     // if it's been a moment since the user started
  //     // then assume it was a drag action, not a select action
  //     const clickTimeMs = performance.now() - this.startTimeMs;
  //     if (clickTimeMs > this.maxClickTimeMs) {
  //       return;
  //     }

  //     // if they moved assume it was a drag action
  //     const position = this.getCanvasRelativePosition(event);
  //     const moveDeltaSq = (this.startPosition.x - position.x) ** 2 +
  //                         (this.startPosition.y - position.y) ** 2;
  //     if (moveDeltaSq > this.maxMoveDeltaSq) {
  //       return;
  //     }

  //     const id = this.pickHelper.pick(this.renderer ,position, this.pickingScene, this.camera);
  //     if (id > 0) {
  //       const countryInfo = this.countryInfos[id - 1];
  //       const selected = !countryInfo.selected;
  //       if (selected && !event.shiftKey && !event.ctrlKey && !event.metaKey) {
  //         this.unselectAllCountries();
  //       }
  //       this.numCountriesSelected += selected ? 1 : -1;
  //       countryInfo.selected = selected;
  //       this.setPaletteColor(id, selected ? this.selectedColor : this.unselectedColor);
  //       this.paletteTexture.needsUpdate = true;
  //     } else if (this.numCountriesSelected) {
  //       this.unselectAllCountries();
  //     }
  //     this.requestRenderIfNotRequested();
  //   }

  //   unselectAllCountries() {
  //     this.numCountriesSelected = 0;
  //     this.countryInfos.forEach((countryInfo) => {
  //       countryInfo.selected = false;
  //     });
  //     this.resetPalette();
  //   }

  //   requestRenderIfNotRequested() {
  //     if (!this.renderRequested) {
  //       this.renderRequested = true;
  //       requestAnimationFrame(this.render);
  //     }
  //   }
  // }

  // class GPUPickHelper {
  //   pickingTexture;
  //   pixelBuffer;

  //   constructor() {
  //     // create a 1x1 pixel render target
  //     this.pickingTexture = new THREE.WebGLRenderTarget(1, 1);
  //     this.pixelBuffer = new Uint8Array(4);
  //   }
  //   pick(renderer, cssPosition, scene, camera) {
  //     const { pickingTexture, pixelBuffer } = this;

  //     // set the view offset to represent just a single pixel under the mouse
  //     const pixelRatio = renderer.getPixelRatio();
  //     camera.setViewOffset(
  //       renderer.getContext().drawingBufferWidth,   // full width
  //       renderer.getContext().drawingBufferHeight,  // full top
  //       cssPosition.x * pixelRatio | 0,             // rect x
  //       cssPosition.y * pixelRatio | 0,             // rect y
  //       1,                                          // rect width
  //       1,                                          // rect height
  //     );
  //     // render the scene
  //     renderer.setRenderTarget(pickingTexture);
  //     renderer.render(scene, camera);
  //     renderer.setRenderTarget(null);
  //     // clear the view offset so rendering returns to normal
  //     camera.clearViewOffset();
  //     //read the pixel
  //     renderer.readRenderTargetPixels(
  //       pickingTexture,
  //       0,   // x
  //       0,   // y
  //       1,   // width
  //       1,   // height
  //       pixelBuffer);

  //     const id =
  //       (pixelBuffer[0] << 0) |
  //       (pixelBuffer[1] << 8) |
  //       (pixelBuffer[2] << 16);

  //     return id;
  //   }

}
@Component({
  selector: 'dialog-hiring-dialog',
  templateUrl: './dialog-hirings-dialog.component.html',
})

  export class DialogHiringsDialogComponent implements OnInit {
    requestDemo: FormGroup;
    constructor(
      private FormBuilder: FormBuilder,
      private _snackBar: MatSnackBar,
      private CorporateService: CorporateService,
      public dialogRef: MatDialogRef<DialogHiringsDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public DialogData: any
    ) {
      this.requestDemo=this.FormBuilder.group({
        companyname: ['',Validators.compose([Validators.required])],
        email: ['',[ Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),]],
        level:['',Validators.compose([Validators.required])],
        employee:  ['',Validators.compose([Validators.required,Validators.max(100)])],
        description:  ['',Validators.compose([Validators.required,Validators.minLength(10),])],
      })
    }


    ngOnInit() {
    }
    get companyname() {
      return this.requestDemo.get('companyname');
    }
    get email() {
      return this.requestDemo.get('email');
    }
    getEmailError() {
      if (this.email.hasError('pattern')) {
        return 'Invalid Email';
      }
    }
    get level() {
      return this.requestDemo.get('level');
    }
    get employee() {
      return this.requestDemo.get('employee');
    }
    get description() {
      return this.requestDemo.get('description');
    }
    getDescriptionError(){
      if(this.description.hasError('required')){
        return 'You must enter a value';
      }
      return this.description.errors.minLength == true ? '' : 'Please explain a bit more!';
    }
    onsubmit(){
      console.log(this.requestDemo);
      this.CorporateService.demoRequestCallback(this.requestDemo.value).subscribe(
        (res: any) => {
          console.log('response>>>',res);
          
          if (res.body.success) {
            console.log('response>>>',res.body.success);
            this._snackBar.open(
              'Be patient, Our concern person will contact you soon',
              'Dismiss',
              {
                duration: 3000,
                panelClass: ['my-snack-bar'],
              }
            );
          } else {
            this._snackBar.open('error', 'Dismiss', { duration: 20000 });
          }
        },
        (err: any) => {
          console.log('error>>>>>',err);
          
          this._snackBar.open(err, 'Dismiss', { duration: 20000 });
        }
      );
    }
    }




  //   submitForm() {
  //     console.log(this.applyNow);
  //     this.IndividualService.callBackRequest(this.applyNow.value).subscribe(
  //       (res: any) => {
  //         if (res.body.success) {
  //           this._snackBar.open(
  //             'Be patient, Our concern person will contact you soon',
  //             'Dismiss',
  //             {
  //               duration: 5000,
  //               panelClass: ['my-snack-bar'],
  //             }
  //           );
  //         } else {
  //           this._snackBar.open('error', 'Dismiss', { duration: 20000 });
  //         }
  //       },
  //       (err: any) => {
  //         this._snackBar.open(err, 'Dismiss', { duration: 20000 });
  //       }
  //     );
  //   }

  // }

  